import { useState, useEffect, useRef, useMemo } from "react";
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete"
import QuadralModal from "@quadral/quadral-component-common/dist/components/modal";
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField"
import QuadralDate from "@quadral/quadral-component-common/dist/components/date";
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography";
import QuadralButton from "@quadral/quadral-component-common/dist/components/button"
import { onlineProcessesService } from "../../services";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

// updateRecord 

export default function NewActivityModal({ roles, participationId, deviationId, user, quadralToast, showLoader, hideLoader, updateRecord, updateParticipation }) {
    const [isFieldsFilled,setIsFieldsFilled] = useState(false);
    const [isDeviation, setIsDeviation] = useState(false);
    const [timeValue, setTimeValue] = useState((new Date()));
    const [date, time] = formatDateTime(new Date());
    const [display, setDisplay] = useState('');
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(() => {
        return{
            common: { date, time, escalationMotive: "Justificatif différent de l'attendu", detail: ""},
            call: { callReason: "selectmotive", callConclusion: "", escalationOrigin:""},
            escalation: { escalationStatus: (display === "N2") ? "Retours_a_analyser_interne" : "Retours_a_analyser_externe", subject: ""},
        };
    });
    const [activityRecordBody, setActivityRecordBody] = useState({
        participationId: participationId,
        subject: formData.call.callReason,
        description: formData.common.detail,
        callResult: formData.call.callConclusion,
        origin: formData.call.escalationOrigin
    });

    const handleClose = () => setOpen(false);
    const detailRef = useRef(null);

    const motiveOptions = useMemo(() => [
        {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
        {   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global - Compréhension de l'enquête ou d'une relance", },
        {   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé", },
        {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global - Souhait de confirmer bonne réception du dossier", },
        {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier - Usage - Accompagnement renseignement formulaire", },
        {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)", },
        {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Télédéclaration - Usage - Souhait de réponse au format papier"     },
        {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Télédéclaration - Usage - Téléchargement des pièces"     },
        {   label: "Télédéclaration - Problème technique",      value: "Télédéclaration - Problème technique"     },
        {   label: "Divers - Autres motifs",      value: "Divers - Autres motifs"     },
    ], []);

    const escalationOptions = [
        {   label: "Justificatif différent de l'attendu",    value: "Justificatif_different_de_l_attendu", },
        {   label: 'Inadéquation situation déclarée et justificatifs fournis',    value: "Inadequation_situation_declaree_et_justificatifs_fournis", },
        {   label: 'Situation complexe',    value: "Situation_complexe", },
        {   label: 'Autre',    value: "Autre", },
    ]

    useEffect(() => {
        if(roles.includes("survey-participation.deviation1")){
            setDisplay('N1');
        }
        if(roles.includes("survey-participation.deviation2")){
            setDisplay('N2');
        }
        if(roles.includes("survey-participation.deviation3")){
            setDisplay('N3');
        }
    }, [roles])

    useEffect(() => {
        setIsDeviation(!!(deviationId));
    }, [deviationId])

    useEffect(() => {
        const hasParticipationId = !!participationId;
        const hasCallConclusionOrDeviation = !!(formData.call.callConclusion || isDeviation);
        const hasEscalationOriginIfEscalade = formData.call.callConclusion === "Escalade" ? formData.call.escalationOrigin !== "" : true;
        const hasCallReason = !!formData.call.callReason;
        const hasValidCallReason = formData.call.callReason !== "selectmotive";
        const hasDetail = formData.common.detail.toString().trim() !== "";
        const fieldsFilled = !!(
            hasParticipationId &&
            hasCallConclusionOrDeviation &&
            hasEscalationOriginIfEscalade &&
            hasCallReason &&
            hasValidCallReason &&
            hasDetail
        );

        setActivityRecordBody({
            participationId: participationId,
            subject: formData.call.callReason,
            description: `${user} : ${formData.common.detail}`,
            callResult: !isDeviation ? formData.call.callConclusion : "Resolu",
            origin: formData.call.escalationOrigin
        });
        setIsFieldsFilled(fieldsFilled);
    },[formData, isDeviation, participationId, deviationId, user])

    function formatDateTime(date) {
        const twoNum = (n) => (n < 10 ? '0' + n : n);

        const day = twoNum(date.getDate());
        const month = twoNum(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = twoNum(date.getHours());
        const minutes = twoNum(date.getMinutes());

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    function normalizeInputValue(value) {
        return value && value.target ? value.target.value : value;
    }

    function handleChange(newValue, field) {
        const normalizedValue = normalizeInputValue(newValue);
        switch (field){
            case "date" :
                setTimeValue(newValue);
                updateFormSection("common", "date", `${newValue.$D}/${newValue.$M+1}/${newValue.$y}`);
                updateFormSection("common", "time", `${newValue.$H}:${newValue.$m}`);
            break;
            
            case "subject":
            case "escalationStatus":
                updateFormSection("escalation", field, normalizedValue);
                break;

            case "callReason":
            case "callConclusion":
            case "escalationOrigin":
                updateFormSection("call", field, normalizedValue);
                break;

            default:
                updateFormSection("common", field, normalizedValue);
                break;
        }
    }

    
    function updateFormSection(section, field, newValue) {
        setFormData(formData => ({
            ...formData,
            [section]: {
            ...formData[section],
            [field]: newValue,
            },
        }));
    }

    function sendReport() {
        if (!isFieldsFilled){
            quadralToast.error("Veuillez compléter tous les champs obligatoires s'il vous plait");
            return;
        }else{
            return createActivity();
        }
    }

    function createActivity(){
        showLoader();
        onlineProcessesService.createActivityRecord({participationId}, activityRecordBody)
            .then(dataReceived => {
                setActivityRecordBody(dataReceived);
                updateRecord();
                hideLoader();
                emptyFields();
                handleClose();
                if(!isDeviation) { 
                    updateParticipation();
                }
            })
            .catch(err => {
                console.error(err);
                hideLoader();
        });
    }

    function emptyFields(){
        handleChange("","callReason");
        handleChange("","detail");
        if(detailRef.current) detailRef.current.value = "";
    }

    return (
        <QuadralModal
            open={open}
            setOpen={setOpen}
            ButtonText={
                <>
                    <FontAwesomeIcon icon={faPlus} style={{marginRight: "0.25rem"}}/>
                    Saisir une activité
                </>
            }
            title='Nouvelle activité - Appel'
            action={<>
                <QuadralButton 
                    size="medium"
                    color="secondary"
                    label='Fermer'
                    onClick={() => handleClose()}
                />
                <QuadralButton
                    size="medium"
                    color="primary"
                    label='Enregistrer'
                    onClick={() => sendReport()}
                />
            </>}
        >
            <QuadralContainer orientation='row'>
                <QuadralContainer orientation='column' col sm={12} md={7}>
                    <QuadralDate 
                        value={timeValue}
                        disabled={true}
                        placeholder="jj/mm/aaaa hh:mm"
                        onChange={(value) => handleChange(value, "date")}
                        label="Date et heure"
                        noPadding  
                        dateAndTime
                    />
                </QuadralContainer>
            </QuadralContainer>
            <QuadralContainer orientation='column' col sm={12} md={12}>
                <QuadralAutocomplete
                    required
                    label="Sujet d'appel"
                    value={motiveOptions.find(o => o.value === formData.call.callReason) ?? null}
                    onChange={(event, option) => handleChange(option.value, "callReason")}
                    aria-label="Select Label"
                    id="callReasonField"
                    options={motiveOptions}
                    getOptionLabel={(option) => option.label}
                    noPadding
                />
            </QuadralContainer>
            <QuadralContainer orientation='row'>
                <QuadralContainer orientation='column' col sm={12} md={12}>
                    <QuadralTextField 
                        required
                        label="Commentaire"
                        id="standard-basic" 
                        ref={detailRef}
                        onChange={(value) => handleChange(value, "detail")} 
                        multiline
                        rows={4}
                        noPadding
                    />
                </QuadralContainer>
            </QuadralContainer>
            {(!isDeviation)&& (
                <>
                <QuadralContainer>
                    <QuadralTypography variant='label'>Conclusion de l'appel</QuadralTypography>
                    <RadioGroup
                        onChange={(event, value) => handleChange(value, "callConclusion")}
                    >
                        <FormControlLabel control={<Radio/>} label="Situation résolue" value="Resolu"/>
                        <FormControlLabel control={<Radio/>} label="Initier une escalade" value="Escalade"/>
                    </RadioGroup>
                </QuadralContainer>
                {(formData.call.callConclusion === "Escalade") && (
                    <QuadralContainer orientation='row'>
                        <QuadralContainer orientation='column' col sm={12} md={12}>
                            <QuadralAutocomplete
                                label="Motif d'escalade"
                                value={escalationOptions.find(o => o.value === formData.call.escalationOrigin) ?? ""}
                                onChange={(event, option) => handleChange(option.value, "escalationOrigin")}
                                options={escalationOptions}
                                getOptionLabel={(option) => option.label}
                                noPadding
                            />
                        </QuadralContainer>
                    </QuadralContainer>
                )}
                </>
            )}
        </QuadralModal>
    );
}